<template>
  <div>
    <label class="subtitle-1 mb-1 d-block">{{ label }}</label>
    <v-radio-group class="mt-0" v-model="radioVal" :rules="rules" row>
      <v-radio label="Yes" :value="true"></v-radio>
      <v-radio label="No" :value="false"></v-radio>
    </v-radio-group>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      radioVal: null,
    };
  },
  props: {
    value: {
      type: Boolean,
      default: null,
    },
    label: {
      type: String,
      default: "",
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    radioVal() {
      this.$emit("update:value", this.radioVal);
    },
    value: {
      immediate: true,
      handler() {
        this.radioVal = this.value;
      },
    },
  },
});
</script>
